// @flow

import React from 'react';
import prop from 'lodash/fp/prop';
import flow from 'lodash/fp/flow';
import toUpper from 'lodash/fp/toUpper';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import MaskSpinner from 'components/MaskSpinner/MaskSpinner';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import type { ParticipantSearchResult, L10n, VirtualEventStageResult } from 'type/type';

import Search from './Search';
import Submit from './Submit';
import Result from './Result';
import './index.scss';

type Props = {
  endDate: string,
  resultSubmitted: boolean,
  participantInfo: ?ParticipantSearchResult,
  onSearchParticipant: ({ registrationNumber: string }) => void,
  isSearching: boolean,
  resultSubmitted: boolean,
  onSubmitResult: ({ stageResults: Array<VirtualEventStageResult>, fileId: string }) => void,
  isSubmitting: boolean,
  l10n: L10n,
}

const SubmitResult = ({
  endDate,
  participantInfo,
  onSearchParticipant,
  isSearching,
  resultSubmitted,
  onSubmitResult,
  isSubmitting,
  l10n: { formatMessage },
}: Props) => (
  <div className="virtual-event__submit-result">
    <div className="virtual-event__submit-result__alert container">
      <i className="icon-play-circle-o" />
      <L10nMessage id="page.event.virtualEvent.submitResult.alert" />
    </div>
    {!participantInfo && (
      <Search
        endDate={endDate}
        onSearchParticipant={onSearchParticipant} />
    )}
    {!resultSubmitted && participantInfo && (
      <Submit
        participantInfo={participantInfo}
        onSubmitResult={onSubmitResult} />
    )}
    {resultSubmitted && participantInfo && (
      <Result category={
        `${formatMessage(`global.sportsType.${flow(prop('sportType'), toUpper)(participantInfo)}`)}
          -
          ${prop('distanceName')(participantInfo)}`} />
    )}
    {(isSubmitting || isSearching) && <MaskSpinner />}
  </div>
);

SubmitResult.defaultProps = {
  participantInfo: null,
};

export default injectL10n()(SubmitResult);
